import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";

const useExtrasLogic = () => {
  const apiRoute = "addons";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "name",
      label: "Extra Name",
      type: "text",
      isRequired: true,
      err: "Extra Name is required",
      disableEditForNonAdmin: true,
    },
    {
      name: "category",
      label: "Category",
      type: "dropdown",
      isRequired: false,
      err: "Category is required",
      returnID: true,
    },
    {
      name: "limit",
      label: "Limit",
      type: "number",
      minValue: 0,
      isRequired: false,
      err: "Limit is required",
      decimalCount: 0,
    },
    {
      name: "allow_frontend",
      label: "Show on frontend?",
      type: "toggle",
      isRequired: false,
      err: "Show on frontend? is required",
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, financeRole, managerRole];
  const deleteRoles = [admin, financeRole, managerRole];
  const editRoles = [admin, financeRole, managerRole];

  const getPromises = (temp) => {
    return [
      fetchDataAndMapToField(config, "addOnCategories", "category", temp),
    ];
  };

  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    getPromises,
    onlyForm,
  };
};

export default useExtrasLogic;
